import { HttpErrorResponse } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { NestApiProvider } from '../nest-api';
import { responseObj } from '../nest-model/nest-model';
import { NestResponsesProvider, ResponseData } from '../nest-responses';

@Injectable()
export class PurchaseRequestApi {

  private service: string = '';
  private model: string = 'erp/purchaserequest';

  constructor(
    public nestApiProvider: NestApiProvider,
    public nestResponseProvider: NestResponsesProvider,
  ) {
  }

  public getrequestinbox(payload: { requestNo: string}): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getrequestinbox';
    const params: any = payload || {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public getRequest(payload: { requestNo: string}): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getRequest';
    const params: any = payload || {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
  
  public getSelectedItem(payload: { items: any}): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getSelectedItem';
    const params: any = payload || {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  } 

  public getListPurchaseReq(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getListPurchaseReq';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, _params, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public getComponentERP(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getComponentERP';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, _params, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public getItem(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getItem';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, _params, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public getActivePRType(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'isPRTypeActive';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, _params, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public getPRType(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getPRType';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this.model, _func, _params, _urlParams, this.service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public getRequestDetail(payload: { id: number}): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getRequestDetail';
    const params: any = payload || {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
  
  save(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "save";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = formData;
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  insertUpload(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "insertUpload";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = formData;
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  add(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "add";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = formData;
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  public responseError(response: HttpErrorResponse): Promise<void> {
    return new Promise(async (resolve) => {
      await this.nestResponseProvider.error(response);
      resolve();
    });
  }

  delete(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "delete";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = formData;
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

}


// WEBPACK FOOTER //
// ./src/shared/nestjs/erp/purchaserequest.api.ts